export const RESUME_TARIFFS_EDIT_MODAL_NAME = 'resumeTariffsEdit';
